<template>
  <div>
    <top-bar heading="Upload Video"></top-bar>
    <div class="container-fluid mt-3">
      <b-card class="p-3">
        <div class="row">
          <div class="col-12 mb-3">
            <label class="control-label visible-ie8 visible-ie9" for="videoTitle">Video Name</label>
            <input :class="{'form-control': true, 'is-invalid': errors.has('videoTitle')}"
                   v-validate="'required'"
                   data-vv-delay="500"
                   data-vv-as="Video Name"
                   data-vv-name="videoTitle"
                   type="text"
                   placeholder="Video Name"
                   name="videoTitle"
                   id="videoTitle"
                   v-model="videoTitle"/>
            <div class="invalid-tooltip d-block" v-if="errors.has('videoTitle')">{{ errors.first('videoTitle') }}</div>
          </div>
          <div class="col-12 mb-3">
            <label class="control-label visible-ie8 visible-ie9" for="description">Description</label>
            <textarea :class="{'form-control': true, 'is-invalid': errors.has('description')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Description"
                      data-vv-name="description"
                      type="text"
                      placeholder="Description"
                      name="description"
                      id="description"
                      v-model="videoDescription"></textarea>
            <div class="invalid-tooltip d-block" v-if="errors.has('description')">{{ errors.first('description') }}</div>
          </div>
          <div class="col-12 mb-3">
            <label class="d-block mb-2">Roles (For Display in Library)</label>
            <b-form-checkbox-group v-model="selectedRoles" buttons button-variant="outline-primary" name="butons1" :options="roles"></b-form-checkbox-group>
          </div>
          <div class="col">
            <label class="control-label visible-ie8 visible-ie9" for="category">Category</label>
            <select :class="{'form-control': true, 'is-invalid': errors.has('category')}"
                    v-validate="'required'"
                    data-vv-delay="500"
                    data-vv-as="Category"
                    data-vv-name="category"
                    type="text"
                    name="category"
                    id="category"
                    v-model="category">
              <option value="Course Material">Course Material</option>
              <option value="Tutorial">Tutorial</option>
              <option value="Guide">Guide</option>
              <option value="Product Information">Product Information</option>
              <option value="Other">Other</option>
            </select>
            <div class="invalid-tooltip d-block" v-if="errors.has('category')">{{ errors.first('category') }}</div>
          </div>
          <div class="col-12 mb-3">
            <label>Video File</label>
            <b-form-file v-model="videoFile" accept="video/*" v-validate="'required'"></b-form-file>
            <div class="invalid-tooltip d-block" v-if="errors.has('videoFile')" data-vv-as="videoFile" data-vv-name="videoFile">{{ errors.first('videoFile') }}</div>
          </div>
          <div class="col-12 mb-3">
            <loading-button @submit="submit" block :loading="loading" :disabled="errors.any() || progress > 0">
              <font-awesome-icon icon="cloud-upload-alt"></font-awesome-icon>
              Upload
            </loading-button>
          </div>
          <div class="col-12 mb-3" v-if="progress">
            <h5>Uploading...</h5>
            <b-progress :value="progress" height="20px" :max="100" show-progress animated></b-progress>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
let VimeoUpload = require('vimeo-upload');
export default {
  name: 'UploadVideoLibrary',
  data () {
    return {
      token: '',
      videoFile: null,
      videoTitle: '',
      videoDescription: '',
      progress: 0,
      loading: false,
      category: '',
      selectedRoles: []
    };
  },
  methods: {
    submit () {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.uploadFile();
        }
      });
    },
    uploadFile () {
      this.loading = true;
      let vm = this;

      this.updateProgress(0);

      let vUpload = new VimeoUpload({
        name: vm.videoTitle,
        file: vm.videoFile,
        token: vm.token,
        upgrade_to_1080: true,
        descripton: vm.videoDescription,
        metadata: {
          privacy: {
            add: false,
            comments: 'nobody',
            download: false,
            embed: 'whitelist',
            view: 'unlisted'
          }
        },
        onError: (data) => {
          vm.loading = false;
          vm.updateProgress(0);
          vm.$errorOut(JSON.parse(data).error);
        },
        onProgress: function (data) {
          console.log(data);
          vm.updateProgress(data.loaded / data.total);
        },
        onComplete: function (videoId) {
          vm.createVideo(videoId);
        }
      });

      vUpload.upload();
    },
    updateProgress (progress) {
      this.progress = Math.floor(progress * 100);
    },
    createVideo (id) {
      this.loading = false;
      this.updateProgress(0);
      this.$swal('Success', 'Video Uploaded', 'success');

      let params = {
        title: this.videoTitle,
        vimeo_id: id,
        roles: this.selectedRoles,
        category: this.category
      };

      this.axios.post('/video_library', params);

      this.videoFile = null;
      this.videoTitle = '';
      this.videoDescription = '';
      this.selectedRoles = [];
      this.category = '';
    }
  },
  mounted () {
    this.$store.dispatch('LOAD_ROLES', this);
    this.axios.get('/video_library/token').then(rsp => {
      this.token = rsp.data;
    });
  },
  computed: {
    roles () {
      return this.$store.state.roles.map(role => {
        return {text: role.name, value: role.id};
      });
    }
  },
  metaInfo: {
    title: 'Upload Video'
  }
};
</script>
